import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  carouselImage: {
    objectFit: "cover",
    width: "100%",
    height: "500px",
    margin: "0 5%",
    borderRadius: "0.3em",
    [theme.breakpoints.down("sm")]: {
      objectFit: "cover",
      width: "100%",
      height: "300px",
      margin: "0",
    },
  },
}));

const ServiceSliderItem = ({ imageURL, title }) => {
  const classes = useStyles();

  return (
    <div>
      <img
        alt={title}
        className={`carouselItem ${classes.carouselImage}`}
        src={imageURL}
      ></img>
    </div>
  );
};

export default ServiceSliderItem;
